export const WORKOUT = 'workout';
export const TYPE = 'type';
export const SUBTYPE = 'subtype';